var map = {
	"./address.svg": 657,
	"./athensLogo.svg": 546,
	"./coloredAthensLogo.png": 113,
	"./email.svg": 927,
	"./facebookIcon.jpeg": 855,
	"./flatAthensLogo.png": 822,
	"./hamburger.svg": 695,
	"./info.svg": 706,
	"./instagramIcon.jpeg": 516,
	"./phone.svg": 359,
	"./tikTokIcon.svg": 71,
	"./whiteHeaderImgText.png": 748,
	"./youtubeIcon.jpeg": 731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 885;